<template>
  <v-card flat class="sblock-list pa-4">
    <s-block
      v-for="(SBlock, index) in SBlocksArray"
      :s-block="SBlock"
      :key="'sblock-index-' + index"
      @delete="deleteSBlock(index)"
    >
    </s-block>
    <v-card-actions>
      <v-spacer>
      </v-spacer>
      <template v-if="$store.getters.loadedSBlockTypes">
        <v-btn fab small color="#ec1946" class="ma-4" @click="openSBlockTypeSelection = true">
          <v-icon color="white">
            mdi-plus
          </v-icon>
        </v-btn>
        <v-dialog v-model="openSBlockTypeSelection" max-width="40%">
          <s-block-type-selection @selected="addSBlock">
          </s-block-type-selection>
        </v-dialog>
      </template>
      <template v-else>
        <v-progress-circular
          indeterminate
          color="#ec1946"
        ></v-progress-circular>
      </template>
      <v-spacer>
      </v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import SBlock from './SBlock'
import SBlockTypeSelection from './SBlockTypeSelection'
export default {
  name: 'SBlocksList',
  components: { SBlockTypeSelection, SBlock },
  props: {
    SBlocksArray: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      openSBlockTypeSelection: false
    }
  },
  methods: {
    addSBlock (SBlockType) {
      const newSBlockType = {
        id: SBlockType.id,
        name: SBlockType.name,
        description: SBlockType.description
      }
      const newSBlock = {
        type: newSBlockType,
        struct: []
      }
      this.SBlocksArray.push(newSBlock)
      this.openSBlockTypeSelection = false
    },
    deleteSBlock (SBlockIndex) {
      this.SBlocksArray.splice(SBlockIndex, 1)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/colors';
  .sblock-list {
    background-color: white; //$itmo-blue;
  }
</style>
